export default __webpack_public_path__ + "static/media/34.9474fa94.png";